import { animate, inView, scroll } from "vendor";
/* ─── progress-bar ──────────────────────────────────────────────────── */
var ProgressBar = class extends HTMLElement {
  #allowUpdatingProgress;
  constructor() {
    super(...arguments);
    this.#allowUpdatingProgress = !this.hasAttribute("animate-on-scroll");
  }
  static get observedAttributes() {
    return ["aria-valuenow", "aria-valuemax"];
  }
  connectedCallback() {
    if (this.hasAttribute("animate-on-scroll")) {
      inView(this, () => {
        this.#allowUpdatingProgress = true;
        this.#calculateProgressBar();
      });
    }
  }
  get progress() {
    return Math.min(1, this.getAttribute("aria-valuenow") / this.getAttribute("aria-valuemax"));
  }
  set valueMax(value) {
    this.setAttribute("aria-valuemax", value);
  }
  set valueNow(value) {
    this.setAttribute("aria-valuenow", value);
  }
  attributeChangedCallback() {
    if (this.#allowUpdatingProgress) {
      this.#calculateProgressBar();
    }
  }
  #calculateProgressBar() {
    this.style.setProperty("--progress", `${this.progress}`);
  }
};
if (!window.customElements.get("progress-bar")) {
  window.customElements.define("progress-bar", ProgressBar);
}
